export default [
  {
    name: "RegisterClientUser",
    url: "/user/register",
    method: "POST",
    mock: false,
  },
  // 获取客户列表
  // {
  //   name: "GetClientUserList",
  //   url: "/user/list-for-broker",
  //   method: "GET",
  //   mock: false,
  // },
  // 获取客户详情
  // {
  //   name: "GetClientUserDetail",
  //   url: "/user/get-for-broker",
  //   method: "GET",
  //   mock: false,
  // },
  // 获取客户个人资料
  {
    name: "GetClientUserInfo",
    url: "/user/get",
    method: "GET",
    mock: false,
  },
  // 客户认证步骤保存
  {
    name: "SaveClientauthentication",
    url: "/user/save",
    method: "POST",
    mock: false,
  },
  // 获取用户认证步骤信息
  {
    name: "GetClientRegisterFlow",
    url: "/user/get-register-template",
    method: "GET",
    mock: false,
  },
  // 获取客户详情
  // {
  //   name: "CreateClientUser",
  //   url: "/user/create-for-broker",
  //   method: "POST",
  //   mock: false,
  // },
  // 保存kyc认证并申请账户
  {
    name: "AuditAccountApplication",
    url: "/application/account/create",
    method: "POST",
    mock: false,
  },
  // 出入金相关接口

  // 查询所持账户的余额 查询可用账号的接口 传type区分 deposit
  {
    name: "GetAccountBalance",
    url: "/account/balance/list",
    method: "GET",
    mock: false,
  },
  // 获取账号关联的服务器
  {
    name: "GetTradingAccountServer",
    url: "/trading/account/servers/get",
    method: "GET",
    mock: false,
  },
  // 获取未处理入金订单数量
  {
    name: "GetDepositDraftedCount",
    url: "/trading/deposit/drafted/count",
    method: "GET",
    mock: false,
  },
  // 基于货币对返回汇率
  {
    name: "GetCurrencyExchangeRate",
    url: "/trading/currency/exchange-rate/get",
    method: "GET",
    mock: false,
  },
  // 获取可用货币列表
  {
    name: "GetTradingCurrencyList",
    url: "/trading/currency/list",
    method: "GET",
    mock: false,
  },
  // 取消入金申请
  {
    name: "CancelTradingDeposit",
    url: "/trading/deposit/cancel",
    method: "POST",
    mock: false,
  },
  // 获取可用的入金渠道
  {
    name: "GetDepositChannel",
    url: "/trading/deposit/channel/list",
    method: "GET",
    mock: false,
  },

  // 创建入金申请草稿
  {
    name: "CreateDepositDraft",
    url: "/trading/deposit/draft/create",
    method: "POST",
    mock: false,
  },
  // 获取未提交入金申请草稿
  {
    name: "GetDepositDraft",
    url: "/trading/deposit/draft/get",
    method: "GET",
    mock: false,
  },

  // 提交入金申请(支付确认)
  {
    name: "SubmitDeposit",
    url: "/trading/deposit/submit",
    method: "POST",
    mock: false,
  },
  // 查询入金历史记录
  {
    name: "GetDepositHistoryList",
    url: "/trading/history/deposit/list",
    method: "GET",
    mock: false,
  },
  // 查询出金历史记录
  {
    name: "GetWithdrawalHistoryList",
    url: "/trading/history/withdrawal/list",
    method: "GET",
    mock: false,
  },
  // 出金
  // 获取可用的出金渠道
  {
    name: "GetWithdrawalChannelList",
    url: "/trading/withdrawal/channel/list",
    method: "GET",
    mock: false,
  },
  // 创建出金申请
  {
    name: "CreateWithdrawal",
    url: "/trading/withdrawal/create",
    method: "POST",
    mock: false,
  },
  // 转账
  // 创建转账申请
  {
    name: "CreateTransfer",
    url: "/application/transfer/create",
    method: "POST",
    mock: false,
  },
  // 获取转账历史
  {
    name: "GetTransferHistoryList",
    url: "/application/transfer/list",
    method: "GET",
    mock: false,
  },
  // 获取可用的汇率列表
  {
    name: "GetSymbolRateList",
    url: "/trading/symbol/rate/list",
    method: "GET",
    mock: false,
  },
  // 获取可用的网络
  {
    name: "GetCryptoNetwork",
    url: "/trading/crypto/networks/list",
    method: "GET",
    mock: false,
  },
  // 模拟入金
  {
    name: "DemoAccountUpdateBalance",
    url: "/trading/demo-account/update-balance",
    method: "POST",
    mock: false,
  },
  // 获取软件下载工具列表
  {
    name: "ClientListTool",
    url: "/tool/list",
    method: "GET",
    mock: false,
  },
  // 出金地址簿相关接口
  // 创建出金地址簿
  {
    name: "CreateWithdrawalAccountBook",
    url: "/withdrawal/account-book/create",
    method: "POST",
    mock: false,
  },
  // 获取出金地址簿列表
  {
    name: "GetWithdrawalAccountBookList",
    url: "/withdrawal/account-book/list",
    method: "GET",
    mock: false,
  },
  // 获取出金地址簿详情
  {
    name: "GetWithdrawalAccountBookDetail",
    url: "/withdrawal/account-book/get",
    method: "GET",
    mock: false,
  },
  // 更新出金地址簿
  {
    name: "UpdateWithdrawalAccountBook",
    url: "/withdrawal/account-book/update",
    method: "POST",
    mock: false,
  },
  // 删除出金地址簿
  {
    name: "DeleteWithdrawalAccountBook",
    url: "/withdrawal/account-book/delete",
    method: "POST",
    mock: false,
  },
  // 获取交易工具栏目多语言详情
  {
    name: "GetTradingToolColumnI18n",
    url: "/trading-tool/column-i18n/get",
    method: "GET",
    mock: false,
  },
  // 标记交易工具弹窗已读
  {
    name: "MarkTradingToolPopupRead",
    url: "/trading-tool/popup/mark-read",
    method: "POST",
    mock: false,
  },
  // 获取消息详情
  {
    name: "GetClientMessageDetail",
    url: "/message/get",
    method: "GET",
    mock: false,
  },
  // 获取消息列表
  {
    name: "GetClientMessageList",
    url: "/message/list",
    method: "GET",
    mock: false,
  },
  // 标记消息已读
  {
    name: "MarkClientMessageRead",
    url: "/message/mark-read",
    method: "POST",
    mock: false,
  },
  // 隐藏消息
  {
    name: "HideClientMessage",
    url: "/message/hide",
    method: "POST",
    mock: false,
  },
  // 获取未读消息数量
  {
    name: "GetClientMessageUnreadCount",
    url: "/message/unread-count",
    method: "GET",
    mock: false,
  },
  // 创建电子认证相关
  // 创建电子认证回话,返回认证调整URL
  {
    name: "EVerifyCreateSession",
    url: "/e-verify/create-session",
    method: "POST",
    mock: false,
  },
  // 轮询查询电子认证结果 session_id
  {
    name: "EVerifyGetResult",
    url: "/e-verify/get-result",
    method: "GET",
    mock: false,
  },

];
